/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:767.98px){.btn-lg[_ngcontent-%COMP%]{padding-left:.5rem;padding-right:.5rem;font-size:.875rem;line-height:1.5}}"];
export { styles as styles };
